import { render, staticRenderFns } from "./productDevice.vue?vue&type=template&id=59b0d612&scoped=true&"
import script from "./productDevice.vue?vue&type=script&lang=js&"
export * from "./productDevice.vue?vue&type=script&lang=js&"
import style0 from "./productDevice.vue?vue&type=style&index=0&id=59b0d612&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b0d612",
  null
  
)

export default component.exports